import { FaGlobe, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import hospitalLogoWhite from '../assets/logo/mukti-logo-white.png';
import { Link } from 'react-router-dom';

// C5 slip (162x229mm). Flow-based (paginates), footer at bottom.
export const PrintBillLayoutA5 = ({ className, billInfo, table, summary, note, footer, title = 'Hospital Bill' }) => {
  return (
    <div className={`${className} hidden`}>
      <style>{`
        @media print {
          @page { size: 162mm 229mm; margin: 0; }
          html, body { margin: 0 !important; padding: 0 !important; }

          body * { visibility: hidden; }
          .print-wrapper, .print-wrapper * { visibility: hidden; }
          .${className}, .${className} * { visibility: visible; }
          .${className} { display: block !important; position: absolute; left: 0; top: 0; width: 162mm; }

          .${className} *, .header-gradient, .fbar, .fcontact, th, .fcontact::after {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          .c5-slip { display: flex; flex-direction: column; min-height: 229mm; box-sizing: border-box; color: #1f2937; font-size: 11pt; }

          .c5-header {
            display: flex; align-items: center; justify-content: space-between;
            padding: 7px 10mm; color: #fff;
            background: linear-gradient(120deg, #323290, #009650) !important;
          }
          .c5-header img { width: 130px; height: auto; }
          .c5-hcontact { text-align: right; font-size: 9.5px; line-height: 1.4; }
          .c5-hcontact p { margin: 0; }

          .c5-body { flex: 1 0 auto; padding: 9px 10mm 0; }
          .c5-title { text-align: center; font-size: 17pt; font-weight: bold; color: #323290; text-decoration: underline; margin-bottom: 8px; }
          .c5-billinfo { display: grid; grid-template-columns: 1fr 1fr; gap: 0 20px; font-size: 11pt; line-height: 1.5; margin-bottom: 10px; }
          .c5-billinfo p { margin: 0 0 1px 0; }
          .c5-billinfo .full { grid-column: 1 / -1; }
          .c5-billinfo > div { display: contents; }

          .c5-body table { width: 100%; border-collapse: collapse; margin-bottom: 9px; }
          .c5-body th, .c5-body td { border: 1px solid #dcdcdc; padding: 5px 8px; text-align: left; line-height: 1.3; font-size: 10.5pt; }
          .c5-body th { background: #323290 !important; color: #fff !important; font-weight: bold; }
          .c5-body tbody tr:nth-child(even) { background: #f6f8ff; }
          .c5-body td:last-child, .c5-body th:last-child { text-align: right; }

          .c5-summary { display: flex; justify-content: flex-end; }
          .c5-summary .summary-container { width: 56%; }
          .c5-summary .summary-container div { display: flex; justify-content: space-between; padding: 2.5px 8px; border-bottom: 1px dashed #ccc; font-size: 11pt; line-height: 1.35; }
          .c5-summary .summary-container div:last-child { font-weight: bold; font-size: 13pt; color: #009650; border-top: 2px solid #009650; border-bottom: none; margin-top: 3px; padding-top: 4px; }
          .c5-sign { margin-top: 24px; font-size: 10.5pt; }

          .c5-footer { margin-top: 8px; }
          .fcontact { position: relative; overflow: hidden; background: #e8f0ed !important; padding: 6px 10mm; }
          .fcontact::after { content: ''; position: absolute; top: 0; right: 0; width: 90px; height: 100%; background: #009650 !important; clip-path: polygon(25% 0,100% 0,100% 100%,0 100%); }
          .fgrid { position: relative; z-index: 1; display: grid; grid-template-columns: 1fr 1fr; gap: 2px 16px; font-size: 7.5pt; }
          .fgrid p { display: flex; align-items: center; gap: 5px; margin: 0; }
          .fbar { display: flex; align-items: center; justify-content: space-between; background: #1f2937 !important; color: #fff; padding: 5px 10mm; font-size: 7.5pt; }
          .fbar p { margin: 0; }
        }
      `}</style>

      <div className="c5-slip">
        {/* Header */}
        <div className="c5-header">
          <img src={hospitalLogoWhite} alt="Mukti Hospital" />
          <div className="c5-hcontact">
            <p>+880 1601-666893</p>
            <p>muktihospitalpvtlimited@gmail.com</p>
            <p>https://muktihospital.com</p>
          </div>
        </div>

        {/* Body */}
        <div className="c5-body">
          <div className="c5-title">{title}</div>
          {billInfo && <div className="c5-billinfo">{billInfo}</div>}
          {table && <table>{table}</table>}
          {summary && (
            <div className="c5-summary">
              <div className="summary-container">{summary}</div>
            </div>
          )}
          {note && <div style={{ width: '50%' }}>{note}</div>}
          {footer && <div className="c5-sign">{footer}</div>}
        </div>

        {/* Footer */}
        <div className="c5-footer">
          <div className="fcontact">
            <div className="fgrid">
              <p><FaPhoneAlt size={8} /> <span>+880 1601-666893</span></p>
              <p><FaMapMarkerAlt size={8} /> <span>Race Course, Sasongacha, Cumilla</span></p>
              <p><FaEnvelope size={8} /> <span>muktihospitalpvtlimited@gmail.com</span></p>
              <p><FaGlobe size={8} /> <span>https://muktihospital.com</span></p>
            </div>
          </div>
          <div className="fbar">
            <p>Software Powered By: Microters</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <Link href="https://microters.com/" style={{ display: 'flex', alignItems: 'center', gap: 4 }}><FaGlobe size={8} /> https://microters.com</Link>
              <p style={{ display: 'flex', alignItems: 'center', gap: 4, margin: 0 }}><FaPhoneAlt size={8} /> +880 162-519-2766</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};